import { createContext } from "react";

export const LoaderContext = createContext<boolean>(false);

export const LoaderDispatchContext = createContext<any>(null);

export function loaderReducer(state, action) {
  if (action.type === "update") {
    return action.payload
  } else {
    return state
  }
}
